module.exports = __webpack_public_path__ + "static/media/done@2x.5ad83349.png";